import { render, staticRenderFns } from "./family_references.vue?vue&type=template&id=0c8540bf&"
import script from "./family_references.vue?vue&type=script&lang=js&"
export * from "./family_references.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports